import { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { Cropper, type CropperRef } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';
import { useTranslation } from 'react-i18next';
import spinnerTitle from 'components/others/spinnerTitle';

interface CropPhotoProps {
    src: string;
    busy: boolean;
    onBack: () => void;
    onApply: (file: File) => void;
}

const CropPhoto = ({ src, busy, onBack, onApply }: CropPhotoProps) => {
    const { t } = useTranslation('common');
    const cropperRef = useRef<CropperRef>(null);

    const handleApply = () => {
        const canvas = cropperRef.current?.getCanvas();
        if (!canvas) return;
        canvas.toBlob((blob) => {
            if (!blob) return;
            onApply(new File([blob], 'product-photo.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.92);
    };

    return (
        <div className="product-photo-crop">
            <div className="product-photo-crop__stage">
                <Cropper
                    ref={cropperRef}
                    src={src}
                    className="product-photo-crop__cropper"
                    stencilProps={{ aspectRatio: 1 }}
                />
            </div>
            <div className="product-photo-crop__actions">
                <Button type="button" size="sm" variant="light" disabled={busy} onClick={onBack}>
                    {t('buttons.back')}
                </Button>
                <Button type="button" size="sm" variant="info" disabled={busy} onClick={handleApply}>
                    {spinnerTitle(t('buttons.apply'), busy, t('buttons.apply'))}
                </Button>
            </div>
        </div>
    );
};

export default CropPhoto;
